export const styles = {
  wrap: (isBuyer: boolean) => ({
    minHeight: `calc(100svh - ${isBuyer ? '282px' : '240px'})`,
  }),
};
